import type { ReactElement } from 'react'
import { NavLink } from 'react-router-dom'
import { PATHS } from '@/app/router/paths'
import { BellIcon, HomeIcon, MoreIcon, UsersIcon } from '@/components/icons'
import type { IconProps } from '@/components/icons'
import { cx } from '@/components/ui/internal/cx'
import './navigation.css'

type NavItem = {
  label: string
  to: string
  icon: (props: IconProps) => ReactElement
}

/** Lower-density caregiver navigation (contract §7). */
const ITEMS: NavItem[] = [
  { label: 'Dashboard', to: PATHS.caregiver.dashboard, icon: HomeIcon },
  { label: 'Cliënten', to: PATHS.caregiver.clients, icon: UsersIcon },
  { label: 'Meldingen', to: PATHS.caregiver.notifications, icon: BellIcon },
  { label: 'Meer', to: PATHS.caregiver.profile, icon: MoreIcon },
]

export function CaregiverNav() {
  return (
    <nav className="caregiver-nav" aria-label="Begeleidersnavigatie">
      <ul className="caregiver-nav__list">
        {ITEMS.map((item) => (
          <li key={item.to} className="caregiver-nav__entry">
            <NavLink
              to={item.to}
              className={({ isActive }) => cx('caregiver-nav__item', isActive && 'caregiver-nav__item--active')}
            >
              <item.icon size={22} />
              <span className="caregiver-nav__label">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
